/** @jsxRuntime classic */
/** @jsx jsx */
// @ts-check
import { jsx } from 'theme-ui';
import DefaultExhibitorPage from '@bottlebooks/gatsby-theme-event/src/components/ExhibitorPage/ExhibitorPage';
import PavilionPage from './PavilionPage';

export * from '@bottlebooks/gatsby-theme-event/src/components/ExhibitorPage/ExhibitorPage';

export default function ExhibitorPage(props) {
  const { exhibitor } = props;

  switch (exhibitor?.exhibitorId) {
    case '5a8c68b9fbf9ae1e19e9f4e9':
      return <PavilionPage {...props} />;
    case '5b45d3c96dc36a1e93472255':
      return <PavilionPage {...props} />;
    default:
      return <DefaultExhibitorPage {...props} />;
  }
}
